<template>
    <div class="pb-0">
        <div class="row mb-4">
            <div class="col-md-5">
                <div class="position-relative">
                    <div v-if="config.modules.view_360 && selectedProduct.images_360 && selectedProduct.images_360.length"
                        class="vue-product-spinner">
                        <img :src="selectedProduct.images_360[image360Position]" class="w-100"
                            :width="config.view_360.width" :height="config.view_360.height">
                        <input type="range" v-model="image360Position" :max="selectedProduct.images_360.length - 1">
                    </div>
                    <Photoswipe v-else>
                        <img :src="_.first(selectedProduct.images)" class="w-100 mb-3 shadow-sm"
                            v-pswp="_.first(selectedProduct.images)" />
                        <div class="row" v-if="selectedProduct.images.length > 1">
                            <div class="col-4" v-for="(image, index) in _.slice(selectedProduct.images, 1)"
                                :key="index">
                                <img :src="imageSmall(image)" class="w-100 shadow-sm" v-pswp="image" />
                            </div>
                        </div>
                    </Photoswipe>
                    <promo-watermark-component :data-product="selectedProduct"
                        data-classes="top-0 start-0 bg-light"></promo-watermark-component>
                </div>
            </div>
            <div class="col">
                <div class="mb-3">
                    <h1 class="h2 d-inline">{{ selectedProduct.name }}</h1>
                    <span v-if="selectedProduct.draft"
                        class="badge rounded-pill bg-secondary ms-2">{{ t.global.draft }}</span>
                    <div v-if="selectedProduct.brand" class="mb-2">
                        <b>{{ t.product.brand }}:</b>
                        <a :href="url('products') + '?brands=' + selectedProduct.brand.slug">
                            {{ selectedProduct.brand.name }}
                        </a>
                    </div>
                    <div v-if="avgRate">
                        <i class="fa-solid fa-star fa-sm"></i> {{ avgRate }}/{{ config.reviews.rate_max_value }}
                        <span class="text-muted text-lowercase">({{ reviewsCount }} {{ t.reviews.reviews }})</span>
                    </div>
                    <div v-if="selectedProduct.ref">Ref.: {{ selectedProduct.ref }}</div>
                </div>
                <div class="h5">
                    <div v-if="variations && variations.length">
                        <div v-if="product.minPrice != product.maxPrice">
                            {{ amountWithCurrency(product.minPrice) }} ~ {{ amountWithCurrency(product.maxPrice) }}
                        </div>
                    </div>
                    <div v-else-if="product.discount_price">
                        <span
                            class="h6 text-decoration-line-through me-2">{{ amountWithCurrency(product.public_price) }}</span>
                        <span>{{ amountWithCurrency(product.price) }}</span>
                    </div>
                    <div v-else>
                        {{ amountWithCurrency(product.price) }}
                    </div>
                </div>
                <div class="mb-3">
                    <div v-if="variations && variations.length" class="d-inline me-3">
                        <label class="fw-bold">{{ t.product.select_options }}</label>
                        <select class="form-select w-auto" v-model="selectedProduct" @change="selectProduct">
                            <option v-for="variation in variations" :key="variation.id" :value="variation">
                                <span v-for="(variationAttribute, index) in product.variationAttributes" :key="index">
                                    <span
                                        v-if="variation.products_attributes_values.find((prod_attr_val) => prod_attr_val.attribute_id == variationAttribute.id)">
                                        {{ variationAttribute.name }}:
                                        <span v-if="variationAttribute.type == 'multi'">
                                            {{ variation.products_attributes_values.find((prod_attr_val) =>
                        prod_attr_val.attribute_id == variationAttribute.id).value.name }}
                                        </span>
                                        <span v-if="variationAttribute.type == 'numeric'">
                                            {{ variation.products_attributes_values.find((prod_attr_val) =>
                        prod_attr_val.attribute_id == variationAttribute.id).numeric_value }}
                                        </span>
                                        <span v-if="variationAttribute.type == 'boolean'">
                                            {{ variation.products_attributes_values.find((prod_attr_val) =>
                        prod_attr_val.attribute_id == variationAttribute.id).boolean_value ?
                        t.global.yes : t.global.no }}
                                        </span>
                                        <span v-if="index != Object.keys(product.variationAttributes).length - 1"> /
                                        </span>
                                    </span>
                                </span>
                            </option>
                        </select>
                    </div>
                    <div v-if="selectedProduct" class="d-inline">
                        <div v-if="selectedProduct.discount_price">
                            <span class="h6 text-decoration-line-through me-2">
                                {{ amountWithCurrency(selectedProduct.public_price) }}
                            </span>
                            <span class="h5">
                                {{ amountWithCurrency(selectedProduct.discount_price) }}
                            </span>
                        </div>
                        <div class="h5" v-else-if="selectedProduct.price">
                            {{ amountWithCurrency(selectedProduct.price) }}
                        </div>
                    </div>
                </div>
                <div class="mb-3" v-html="nl2br(selectedProduct.description)"></div>
                <div v-if="!config.modules.catalog_mode" class="mb-3">
                    <div class="row mb-2" v-if="!config.modules.catalog_mode">
                        <div class="col-md-2">
                            <div class="input-group">
                                <span class="input-group-prepend"><button @click="qty > 1 ? qty-- : false" type="button"
                                        class="btn btn-light border">-</button></span>
                                <input type="text" @focus="$event.target.select()" class="form-control text-center"
                                    v-model.number="qty">
                                <span class="input-group-prepend"><button @click="qty++" type="button"
                                        class="btn btn-light border">+</button></span>
                            </div>
                        </div>
                        <div class="col-md">
                            <!-- <add-to-cart-component :data-product="selectedProduct"></add-to-cart-component> -->
                            <div class="d-inline-block" v-if="!config.modules.catalog_mode">
                                <a v-if="selectedProduct.variations.length" :href="selectedProduct.url">
                                    <i class="fas fa-tasks fa-fw"></i> {{ t.product.select_options }}
                                </a>
                                <div v-else>
                                    <button :disabled="!selectedProduct.canBeOrdered" class="btn btn-primary" @click="addToCart">
                                        <i class="fas fa-shopping-bag fa-fw"></i> {{ t.product.add_to_cart }}
                                    </button>
                                    <a v-if="config.modules.buy_now && selectedProduct.canBeOrdered" class="btn btn-link ms-2 text-decoration-none text-muted" :href="selectedProduct.buyNow"><i class="fa-solid fa-forward"></i> {{ t.product.buy_now }}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="small" v-if="config.modules.stock && selectedProduct.stock !== null && selectedProduct.stock <= 0">
                        <i class="fa-solid fa-triangle-exclamation"></i> {{ settings.order_out_of_stock ?
                        t.product.restocking : t.product.out_of_stock }}
                    </div>
                    <div class="small"
                        v-else-if="config.modules.stock && !settings.order_out_of_stock && selectedProduct.stock && selectedProduct.stock <= settings.low_stock">
                        <i class="fa-solid fa-triangle-exclamation"></i> {{ this.__('product', 'low_stock', {
                        'stock':
                            selectedProduct.stock
                    }) }}
                    </div>
                </div>
                <div v-if="config.modules.wishlist" class="mb-3">
                    <span class="cursor-pointer" @click="toggleToWishlist">
                        <span v-if="this.wishlist.find((product) => product.id == this.selectedProduct.id)">
                            <i class="fas fa-heart"></i> {{ t.wishlist.remove_from_wishlist }}
                        </span>
                        <span v-else>
                            <i class="far fa-heart"></i> {{ t.wishlist.add_to_wishlist }}
                        </span>
                    </span>
                </div>
                <div class="py-3 border-bottom service-logos">
                    <img src="/images/logos/credit-card.jpg">
                    <img src="/images/logos/paypal.jpg">
                    <img src="/images/logos/line-pay.jpg">
                    <img src="/images/logos/apple-pay.jpg">
                </div>
                <div class="py-3 border-bottom service-logos">
                    <img src="/images/logos/7-eleven.jpg">
                    <img src="/images/logos/family-mart.jpg">
                    <img src="/images/logos/hi-life.jpg">
                    <img src="/images/logos/t-cat.jpg">
                    <img src="/images/logos/fedex.jpg">
                    <div v-if="settings.shipping_limit_free" class="mt-2">{{ __('cart', 'free_delivery_limit', {'freeDeliveryLimit': amountWithCurrency(settings.shipping_limit_free)}) }}</div>
                </div>
                <div v-if="loaded && selectedProduct.bundles && selectedProduct.bundles.length" class="mt-3">
                    <div class="h5">{{ t.bundles.bundle_offers }}</div>
                    <div class="row">
                        <div v-for="bundle in selectedProduct.bundles" :key="bundle.id" class="col-6 col-md-4">
                            <bundle-block-component :data-bundle="bundle"></bundle-block-component>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ul class="nav nav-tabs fw-bold">
            <li class="nav-item">
                <a v-if="selectedProduct.long_description" class="nav-link"
                    :class="{ 'active': selectedProduct.long_description }" id="description-tab" data-bs-toggle="tab"
                    href="#description" role="tab" aria-controls="description" aria-selected="true">{{
                        t.product.description }}</a>
            </li>
            <li v-if="selectedProduct.attributeValues.length" class="nav-item">
                <a class="nav-link"
                    :class="{ 'active': !selectedProduct.long_description && selectedProduct.attributeValues.length }"
                    id="attribute-tab" data-bs-toggle="tab" href="#attribute" role="tab" aria-controls="attribute"
                    aria-selected="false">{{ t.product.attributes }}</a>
            </li>
            <li v-if="selectedProduct.video" class="nav-item">
                <a class="nav-link"
                    :class="{ 'active': !selectedProduct.long_description && !selectedProduct.attributeValues.length }"
                    id="video-tab" data-bs-toggle="tab" href="#video" role="tab" aria-controls="video"
                    aria-selected="false">{{ t.product.video }}</a>
            </li>
            <li v-if="config.modules.reviews" class="nav-item">
                <a class="nav-link"
                    :class="{ 'active': !selectedProduct.long_description && !selectedProduct.attributeValues.length && !selectedProduct.video }"
                    id="reviews-tab" data-bs-toggle="tab" href="#reviews" role="tab" aria-controls="reviews"
                    aria-selected="false">{{ t.reviews.reviews }} <span v-if="avgRate" class="fw-normal ms-1"><i
                            class="fa-solid fa-star fa-sm"></i> {{ avgRate
                        }}/{{ config.reviews.rate_max_value }}</span></a>
            </li>
        </ul>
        <div class="tab-content p-3 border border-top-0 mb-5">
            <div v-if="selectedProduct.long_description" class="tab-pane fade"
                :class="{ 'show active': selectedProduct.long_description }" id="description" role="tabpanel"
                aria-labelledby="description-tab" v-html="selectedProduct.long_description"></div>
            <div v-if="selectedProduct.attributeValues.length" class="tab-pane fade"
                :class="{ 'show active': !selectedProduct.long_description && selectedProduct.attributeValues.length }"
                id="attribute" role="tabpanel" aria-labelledby="attribute-tab">
                <div v-for="(attribute, index) in selectedProduct.attributeValues" :key="index" class="row"
                    :class="{ 'bg-light': index % 2 }">
                    <div class="col fw-bold py-2">{{ attribute.name }}</div>
                    <div class="col py-2">
                        <span
                            v-if="attribute.type == 'numeric'">{{ attribute.numeric_value }}{{ attribute.unitName }}</span>
                        <span v-else-if="attribute.type == 'boolean'">{{ attribute.boolean_value ? t.global.yes :
                        t.global.no }}</span>
                        <span v-else>
                            <span v-for="value in attribute.values"
                                :key="value.id">{{ value.name }}{{ attribute.unitName }}</span>
                        </span>
                    </div>
                </div>
            </div>
            <div v-if="selectedProduct.video" class="tab-pane fade"
                :class="{ 'show active': !selectedProduct.long_description && !selectedProduct.attributeValues.length}"
                id="video" role="tabpanel" aria-labelledby="video-tab">
                <iframe width="100%" height="500px" :src="'https://www.youtube.com/embed/'+selectedProduct.video"
                    title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>
            <div v-if="config.modules.reviews" class="tab-pane fade"
                :class="{'active': !selectedProduct.long_description && !selectedProduct.attributeValues.length && !selectedProduct.video}"
                id="reviews" role="tabpanel" aria-labelledby="reviews-tab">
                <reviews-component :productId="selectedProduct.id"></reviews-component>
            </div>
        </div>
    </div>
</template>

<script>
import store from "../CartStore";
import ReviewsComponent from './ReviewsComponent.vue';
import Photoswipe from "vue-pswipe";
Vue.use(Photoswipe);

export default {
    store: store,
    components: {
        ReviewsComponent,
    },
    data() {
        return {
            t: t,
            config: config,
            settings: settings,
            wishlist: wishlist,
            product: product,
            variations: variations,
            selectedProduct: selectedProduct ? selectedProduct : product,
            qty: 1,
            image360Position: 0,
        };
    },
    computed: {
        ...Vuex.mapGetters(['loaded', 'cart']),
        canOrder() {
            if (config.modules.stock && !settings.order_out_of_stock && this.selectedProduct.stock <= 0) {
                return false
            }
            return true
        },
        avgRate() {
            return this.product.avgRate
        },
        reviewsCount() {
            return this.product.reviewsCount
        }
    },
    methods: {
        ...Vuex.mapActions(['addProduct', 'updateProduct', 'addBundle']),
        addToCart() {
            var productToAddToCart = this.product
            if (this.variations && this.variations.length) {
                productToAddToCart = this.selectedProduct;
            }
            productToAddToCart.qty = this.qty
            this.addProduct(productToAddToCart);
        },
        selectProduct() {
            this.image360Position = 0
            this.changeUrl()
        },
        changeUrl() {
            history.replaceState(
                {},
                null,
                this.url('product/' + this.selectedProduct.slug)
            )
        },
        toggleToWishlist() {
            axios
                .post("/ajax/wishlist/toggleToWishlist", {
                    id: this.selectedProduct.id
                })
                .catch((error) => { Vue.notify({ text: error.message, type: 'error' }) })
                .then((response) => {
                    Vue.notify({ text: response.data.message.text, type: response.data.message.type })
                    this.wishlist = response.data.wishlist
                    this.$root.$emit("updateWishlist", response.data.wishlist);
                });
        },
    },
};
</script>
